import AxiosConfig from '../utils/AxiosConfig';

export const getCoreSettings = async () => {
  const response = await AxiosConfig.get('/core-settings');
  return response.data.data || [];
};

export const updateCoreSettings = async (settings) => {
  const payload = { settings };
  await AxiosConfig.post('/core-settings', payload);
  return true;
};
